import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { generateUUID } from 'src/app/shared/utils/functions/codigo-transacao.model';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class SolicitarGarantiaService {

  constructor(private apiService: CoreApiService) { }

  solicitarGarantia(body){
    return this.apiService.post(endpoints.solicitarGarantia, body)
  }

  solicitarGarantiaDPGE(params = {}){
    return this.apiService.get(endpoints.garantiaDPGE, {params})
  }

  solicitarGarantiaEntidadeDPGE(params = {}, idInvestidor: string){
    return this.apiService.get(`${endpoints.garantiaEntidadeDPGE}/${idInvestidor}`, {params})
  }

  realizarSolicitacaoGarantiaDPGE(body,params = {}){
    return this.apiService.post(endpoints.garantiaDPGE,body, {params})
  }

  listarDadosUsuario(){
    return this.apiService.get(`${endpoints.listarUsuarios}?codigoTransacao=${generateUUID()}`)
  }

  acompanharProcessoSolicitacao(params = {}){
    return this.apiService.get(`${endpoints.acompanharProcesso}`, {params})
  }

  listarDetalheSolicitacao(id){
    let params = {codigoTransacao: generateUUID()}
    return this.apiService.get(`${endpoints.garantiaDPGE}/${id}`, {params})
  }

  listarEnderecoUsuario(params = {}){
    return this.apiService.get(`${endpoints.recuperaEnderecoUsuario}`, {params})
  }

  validarCodigoAtivo(params= {}){
    return this.apiService.get(`${endpoints.recuperaCodigoAtivoEntidade}`, {params})
  }

  alterarDadosEntidade(body){
    let params = {codigoTransacao: generateUUID()}

    return this.apiService.put(endpoints.updateEntidade,body ,{params})
  }
  
  alterarDadosInvestidor(body){
    let params = {codigoTransacao: generateUUID()}

    return this.apiService.put(endpoints.updateInvestidor,body ,{params})
  }

  alterarDadosInvestidorOrdinaria(body){
    let params = {codigoTransacao: generateUUID()}
    
    return this.apiService.post(endpoints.updateInvestidorOrdinaria, body, {params})
  }
}
